export const PRODUCTS = [
    {
        slug: 'matrice-400',

        title: 'DJI Matrice 400',
        titleImgRoute: 'assets/logos/matrice-400-logo.svg',
        subtitle: 'Plataforma de drones de larga duración con detección de obstáculos a nivel de líneas eléctricas',
        subsubtitle: 'Ingeniería de excelencia, diseño versátil',
        videoSrc: 'assets/products/m400/banner-video.mp4',

        mainCopy: 'DJI Matrice 400, la plataforma dron insignia para empresas, cuenta con un impresionante tiempo de vuelo de 59 minutos, una capacidad de carga de instrumentos de hasta 6 kg , LiDAR rotativo integrado y radar mmWave para la detección de obstáculos a nivel de las líneas eléctricas. También es compatible con el sistema de transmisión de video mejorado O4 Enterprise y la transmisión de video de relevo aéreo, lo que garantiza un manejo más seguro y operaciones más sencillas. Al combinar detección inteligente con imágenes visibles y térmicas, proyección AR, despegue/aterrizaje en barcos y automatización avanzada, Matrice 400 se destaca en casos de respuesta a emergencias, inspecciones de energía, mapeo y AEC.',
        bannerImg: 'assets/products/m400/banner-img.jpg',

        boxes: [
            {
                title: 'Tiempo de vuelo extendido, rendimiento de alta velocidad',
                src: 'assets/products/m400/box-1.mp4',
                type: 'video'
            },
            {
                title: 'Capacidad de carga útil de 6 kg con compatibilidad versátil',
                src: 'assets/products/m400/box-2.jpg',
                type: 'img'
            },
            {
                title: 'Vuelos seguros y confiables',
                src: 'assets/products/m400/box-3.jpg',
                type: 'img'
            },
            {
                title: 'Inteligencia y eficiencia mejoradas',
                src: 'assets/products/m400/box-4.mp4',
                type: 'video'
            },
            {
                title: 'Operaciones automatizadas más fáciles',
                src: 'assets/products/m400/box-5.mp4',
                type: 'video'
            },
            {
                title: 'Actualizaciones de accesorios completas',
                src: 'assets/products/m400/box-6.jpg',
                type: 'img'
            },
            {
                title: 'DJI Care Enterprise',
                src: 'assets/products/m400/box-7.jpg',
                type: 'img'
            },

        ],

    },
    {
        slug: 'matrice-4',

        title: 'DJI Matrice 4',
        titleImgRoute: 'assets/logos/matrice-4-logo.svg',
        subtitle: 'Dron inteligente compacto multisensor insignia',
        subsubtitle: 'La era del vuelo inteligente',
        videoSrc: 'assets/products/m4t/banner-video.mp4',

        mainCopy: 'Presentamos la serie DJI Matrice 4, una nueva serie de drones insignia multisensor inteligentes y compactos para sectores empresariales. La serie incluye Matrice 4T y Matrice 4E, ambos equipados con funciones avanzadas, como la detección inteligente y la medición con telémetro láser. Las funcionalidades de detección se han mejorado considerablemente para ofrecer operaciones de vuelo más seguras y fiables. También se han aplicado mejoras significativas en los accesorios para la serie Matrice 4. Matrice 4T es adecuado para una amplia gama de aplicaciones, como el sector eléctrico, los sistemas de respuesta en caso de emergencia, la seguridad pública y la conservación forestal. El diseño de Matrice 4E está enfocado a aplicaciones geoespaciales, como la topografía y la cartografía, la construcción y la minería. Se abre una nueva era para las operaciones aéreas inteligentes.',
        bannerImg: 'assets/products/m4t/banner-img.jpg',
        boxes: [
            {
                title: 'Prestaciones de funcionamiento inteligente',
                src: 'assets/products/m4t/box-1.mp4',
                type: 'video'
            },
            {
                title: 'Destaca en entornos con poca luz',
                src: 'assets/products/m4t/box-2.jpg',
                type: 'img'
            },
            {
                title: 'Visión clara e imágenes estables',
                src: 'assets/products/m4t/box-3.jpg',
                type: 'img'
            },
            {
                title: 'Cartografía precisa de alta eficiencia',
                src: 'assets/products/m4t/box-4.mp4',
                type: 'video'
            },
            {
                title: 'Actualizaciones de accesorios completas',
                src: 'assets/products/m4t/box-5.jpg',
                type: 'img'
            },
            {
                title: 'Seguridad de vuelo mejorada',
                src: 'assets/products/m4t/box-6.jpg',
                type: 'img'
            },
            {
                title: 'DJI Care Enterprise',
                src: 'assets/products/m4t/box-7.jpg',
                type: 'img'
            },
        ]
    },
    {
        slug: 'matrice-4-td',
        title: 'DJI Matrice 4TD',
        titleImgRoute: 'assets/logos/matrice-4-td-logo.svg',
        subtitle: 'Drones de alto rendimiento',
        videoSrc: 'assets/products/matrice-4-td/banner-video.mp4',

        mainCopy: 'Los nuevos DJI Matrice 4D y 4TD, resistentes al agua y al polvo, están específicamente diseñados para DJI Dock 3, ofrecen un tiempo de vuelo prolongado, y pueden emparejarse con DJI RC Plus 2 Enterprise para uso independiente. Ambos drones cuentan con una cámara gran angular, una telecámara media, una telecámara y un telémetro láser. Matrice 4D es sumamente eficaz para cartografía profesional de alta precisión e inspecciones minuciosas de superficies. Matrice 4TD está equipado con una cámara térmica infrarroja y una nueva luz NIR auxiliar, por lo que es adecuado para una amplia gama de aplicaciones como inspecciones de infraestructura, respuesta a emergencias y seguridad pública.',
        bannerImg: 'assets/products/matrice-4-td/banner-img.jpg',

        m4tdBoxes: [
            {
                titleImgRoute: 'assets/logos/matrice-4-d-logo.svg',
                img: 'assets/products/matrice-4-td/box-image-4d.jpg',
                sections: [
                    {
                        title: 'Cámara gran angular',
                        content: `
                        CMOS 4/3
                        Píxeles efectivos: 20 MP
                        f/2.8-f/11
                        Formato equivalente a 24 mm
                        Obturador mecánico
                        `
                    },
                    {
                        title: 'Telecámara media',
                        content: `
                        CMOS de 1/1.3 pulgadas
                        Pixeles efectivos: 48 MP
                        f/2.8
                        Formato equivalente a 70 mm
                        `
                    },
                    {
                        title: 'Telecámara',
                        content: `
                        CMOS de 1/1.5 pulgadas
                        Píxeles efectivos: 48 MP
                        f/2.8
                        Formato equivalente a 168 mm`
                    },
                    {
                        title: 'Telémetro láser',
                        content: `
                        Rango de medición: 1800 m (1 Hz);
                        Rango de incidencia oblicua (1: 5 de distancia oblicua): 600 m (1 Hz)
                        Zona ciega: 1 m
                        Precisión de rango (m): ± (0.2 + 0.0015 × D)
                        `
                    }
                ]
            },
            {
                titleImgRoute: 'assets/logos/matrice-4-td-logo.svg',
                img: 'assets/products/matrice-4-td/box-image-4td.jpg',
                sections: [
                    {
                        title: 'Cámara gran angular',
                        content: `
                        CMOS de 1/1.3 pulgadas
                        Píxeles efectivos: 48 MP
                        f/1.7
                        Formato equivalente a 24 mm
                        `
                    },
                    {
                        title: 'Telecámara media',
                        content: `
                        CMOS de 1/1.3 pulgadas
                        Píxeles efectivos: 48 MP
                        f/2.8
                        Formato equivalente a 70 mm
                        `
                    },
                    {
                        title: 'Telecámara',
                        content: `
                        CMOS de 1/1.5 pulgadas
                        Píxeles efectivos: 48 MP
                        f/2.8
                        Formato equivalente a 168 mm
                        `
                    },
                    {
                        title: 'Telémetro láser',
                        content: `
                        Rango de medición: 1800 m (1 Hz);
                        Rango de incidencia oblicua (1: 5 de distancia oblicua): 600 m (1 Hz)
                        Zona ciega: 1 m
                        Precisión de rango (m): ± (0.2 + 0.0015 × D)
                        `
                    },
                    {
                        title: 'Luz NIR auxiliar',
                        content: `Campo de visión de 6°, distancia de iluminación de 100 m`
                    },
                    {
                        title: 'Cámara térmica infrarroja',
                        content: `
                        Resolución 640 × 512
                        f/1.0
                        Formato equivalente a 53 mm
                        Microbolómetro VOx no refrigerado
                        Compatible con el modo de imagen infrarroja UHR
                        `
                    }
                ]
            }
        ]
    },
    {
        slug: 'fh2',
        title: 'DJI FlightHub 2', 
        titleImgRoute: 'assets/logos/fh-logo.svg',
        subtitle: 'Plataforma integral de gestión de drones basada en la nube',
        subsubtitle: 'Descubre la nube, descubre la inteligencia',
        videoSrc: 'assets/products/fh2/banner-video.mp4',

        mainCopy: 'DJI FlightHub 2 es una plataforma integral basada en la nube para la gestión de operaciones dron, que ofrece control remoto, programación inteligente de vuelos, gestión versátil de rutas de vuelo e integración fluida con otros equipos. Gracias a algoritmos inteligentes de reciente introducción y a un modelo multimodal de lenguaje a gran escala (LLM), la plataforma transforma los flujos de trabajo de ingeniería y construcción, y ofrece un sistema de operaciones automatizadas integrado aire-tierra con supervisión visual y control exhaustivos en materia de seguridad pública, respuesta a emergencias, cartografía geoespacial e inspecciones.',

        boxes: [
            {title: 'Operación remota en tiempo real', src: 'assets/products/fh2/box-1.mp4', type: 'video'},
            {title: 'Planificación de vuelo integral', src: 'assets/products/fh2/box-2.jpg', type: 'img'},
            {title: 'Algoritmos inteligentes para inspecciones de precisión', src: 'assets/products/fh2/box-3.jpg', type: 'img'},
            {title: 'Análisis integral de datos', src: 'assets/products/fh2/box-4.mp4', type: 'video'},
            {title: 'Flujos de trabajo automatizados sin interrupciones', src: 'assets/products/fh2/box-5.jpg', type: 'img'},
            {title: 'Integración segura y flexible', src: 'assets/products/fh2/box-6.jpg', type: 'img'}
        ]
    },
    {
        slug: 'dock3',
        title: 'DJI Dock 3',
        titleImgRoute: 'assets/logos/dock3-logo.svg',
        subtitle: 'Primer DJI Dock adaptable para montaje en vehículo',
        subsubtitle: 'Enfrenta cualquier desafío',
        videoSrc: 'assets/products/dock3/banner-video.mp4',

        mainCopy: 'Equipado con drones de alto rendimiento Matrice 4D o Matrice 4TD, DJI Dock 3 permite realizar operaciones remotas 24/7 y, por primera vez, admite el despliegue móvil montado en vehículos para adaptarse sin esfuerzo a diversos entornos. Los drones utilizan las mismas cámaras que la Serie Matrice 4, pero ofrecen un mejor rendimiento de vuelo y protección. También pueden emparejarse con DJI RC Plus 2 Enterprise para uso independiente. Con las funciones inteligentes de DJI FlightHub 2, los pilotos pueden reducir significativamente el tiempo operativo y los costes laborales, maximizando la eficiencia y los ahorros.',

        boxes: [
            {title: 'Domina todos los entornos', src: 'assets/products/dock3/box-1.mp4', type: 'video', },
            {title: 'Operación eficiente con funciones inteligentes', src: 'assets/products/dock3/box-2.jpg', type: 'img'},
            {title: 'Despliegue flexible, transmisión ultra larga', src: 'assets/products/dock3/box-3.jpg', type: 'img', },
            // TODO - ajustar imagen fh2 a otro aspect ratio
            {title: 'Experiencia mejorada con software avanzado', src: 'assets/products/dock3/box-4.jpg', type: 'img', },
            {title: 'Drones de alto rendimiento', src: 'assets/products/dock3/box-5.jpg', type: 'img', },
            {title: 'Seguro y conforme, ecosistema abierto', src: 'assets/products/dock3/box-6.jpg', type: 'img'},
            {title: 'DJI Care Enterprise', src: 'assets/products/dock3/box-6.jpg', type: 'img'}
        ]
    },
    {
        slug: 'terra',
        title: 'DJI Terra',
        titleImgRoute: 'assets/logos/terra-logo.svg',
        subtitle: 'Un software de reconstrucción 3D preciso, inteligente y eficiente.',
        subsubtitle: 'Digitaliza el mundo',
        videoSrc: 'assets/products/terra/banner-video.mp4',

        mainCopy: 'DJI Terra es un software de modelado 3D equipado con tecnologías avanzadas de reconstrucción, incluyendo la dispersión gaussiana 3D. Permite reconstrucciones de luz visible en 2D y 3D precisas y eficientes, y procesamiento de datos a través de DJI LiDAR. Cuando se integra con los drones DJI, Terra ofrece una solución unificada de hardware y software que abarca desde la recopilación de datos hasta el procesamiento y la aplicación de los mismos, haciendo que el trabajo de topografía aérea sea más sencillo, eficiente y preciso.',

        boxes: [
            {title: 'Dispersión gaussiana fotorealista', src: 'assets/products/terra/box-1.mp4', type: 'video', },
            {title: 'Fotogrametría con precisión confiable', src: 'assets/products/terra/box-2.jpg', type: 'img'},
            {title: 'Reconstrucción multiespectral para la agricultura', src: 'assets/products/terra/box-3.jpg', type: 'img', },
            {title: 'Reconstrucción LiDAR con amplias aplicaciones', src: 'assets/products/terra/box-4.mp4', type: 'video', },
            {title: 'Reconstrucción en clúster con alta eficiencia', src: 'assets/products/terra/box-5.jpg', type: 'img', },
            {title: 'Levantamiento aéreo integrado (Hardware + Software)', src: 'assets/products/terra/box-6.jpg', type: 'img'},
        ]
    }
]